module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ua-423c68f9fb154fb2749b64a16d0968e1.svg";